import { render, staticRenderFns } from "./notiItem.vue?vue&type=template&id=19f0cad2&scoped=true"
import script from "./notiItem.vue?vue&type=script&lang=js"
export * from "./notiItem.vue?vue&type=script&lang=js"
import style0 from "./notiItem.vue?vue&type=style&index=0&id=19f0cad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f0cad2",
  null
  
)

export default component.exports